import { render, staticRenderFns } from "./SelectFilter.vue?vue&type=template&id=3935d1a4&scoped=true"
import script from "./SelectFilter.vue?vue&type=script&lang=ts"
export * from "./SelectFilter.vue?vue&type=script&lang=ts"
import style0 from "./SelectFilter.vue?vue&type=style&index=0&id=3935d1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935d1a4",
  null
  
)

export default component.exports